import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import cartUtils from '../../utils/cart';
import cart from '../../utils/cart';
import {
  isShippingRestrictedForParent,
  availableIncentiveProducts,
} from '../v3/helpers/internationalRestriction';

const PreCartOffers = ({ children, history }) => {
  const [checksComplete, setChecksComplete] = useState(false);

  const selectedStudent = useSelector(
    (state) => state.additionalData.selectedStudent,
  );
  const orders = useSelector((state) => state.v3Order.orders);
  const prepayPersonalizationOfferType = useSelector(
    (state) => state.shoot.prepayPersonalizationOfferType,
  );
  const incentiveProducts = useSelector(
    (state) => state.shoot.incentiveProducts,
  );
  const cartVoucherItems = useSelector((state) => state.cartVoucherItems);

  const { preCartOfferProducts, triggersPreCartOfferProducts } = useSelector(
    (state) => state.shoot,
  );
  const eventIsPrepay = useSelector((state) => state?.shoot?.shoot?.is_prepay);
  const shootEventId = useSelector((state) => {
    const s = state.shoot.shoot;
    return s?.event_id || s?.id;
  });
  const shoot = useSelector((state) => state.shoot?.shoot);
  const parent = useSelector((state) => state.parent);

  useEffect(() => {
    const orderKey =
      shootEventId && selectedStudent?.id
        ? `${shootEventId}-${selectedStudent.id}`
        : null;
    const currentOrder = orderKey ? orders[orderKey] : undefined;
    const cartItems = currentOrder?.cartItems || [];
    const shouldPromptForPersonalization =
      currentOrder?.personalization?.shouldPrompt;
    const cartContainsPersonalizableProducts =
      cartUtils.cartContainsPersonalizableProducts(cartItems);

    // Include voucher subtotal in incentive eligibility calculations
    const voucherTotalCents = cartVoucherItems.voucherSubtotalCents || 0;
    const hasVouchers = cartVoucherItems.items?.length > 0;

    const restricted = isShippingRestrictedForParent(shoot, parent);
    const incentiveProductsForRestriction = availableIncentiveProducts(
      incentiveProducts,
      restricted,
    );

    const eligibleIncentivesForCart = cartUtils.eligibleIncentivesForCart(
      orders,
      incentiveProductsForRestriction,
      voucherTotalCents,
    );
    const eligibleIncentivesForOrder = cartUtils.eligibleIncentivesForOrder(
      cartItems,
      incentiveProductsForRestriction,
      voucherTotalCents,
    );

    const preCartOfferProductsToPrompt = cartUtils.preCartOfferProductsToPrompt(
      currentOrder,
      preCartOfferProducts,
      triggersPreCartOfferProducts,
    );

    // Vouchers count as non-incentive products for qualification purposes
    const cartContainsNonIncentiveProducts =
      cartUtils.cartContainsNonIncentiveProducts(cartItems) || hasVouchers;

    if (
      cartContainsNonIncentiveProducts &&
      (eligibleIncentivesForCart?.length > 0 ||
        eligibleIncentivesForOrder?.length > 0)
    ) {
      console.log('pushing to incentives config from cart-based check');
      history.push('/v3/incentives/config');
    } else if (
      eventIsPrepay &&
      prepayPersonalizationOfferType ===
        'prepay_personalization_prompted_before_checkout_only' &&
      cartContainsPersonalizableProducts &&
      shouldPromptForPersonalization
    ) {
      if (eventIsPrepay === false) {
        // TODO: revist this logic
        // Don't show the personalization offer if the event is not prepay
        setChecksComplete(true);
      } else {
        history.push('/v3/personalization-offer');
      }
    } else if (preCartOfferProductsToPrompt.length > 0) {
      history.push('/v3/pre-cart-offers');
    } else {
      setChecksComplete(true);
    }
  }, [
    orders,
    prepayPersonalizationOfferType,
    selectedStudent,
    incentiveProducts,
    preCartOfferProducts,
    cartVoucherItems,
    shoot,
    parent,
  ]);

  if (checksComplete) {
    return children;
  }

  // TODO: render loading spinner
  return <div>Loading...</div>;
};

export default PreCartOffers;
